import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Na <span className="purple">Quantum Tech</span>, oferecemos <span className="purple">dois produtos complementares</span> para impulsionar seu negócio:

            <br /><br />
            <strong><span className="purple">1. Sistema de Gestão Empresarial:</span></strong>
            <ul>
              <li><ImPointRight /> Controle financeiro e contábil completo</li>
              <li><ImPointRight /> Gestão integrada de estoque</li>
              <li><ImPointRight /> Emissão automática de documentos fiscais</li>
              <li><ImPointRight /> Relatórios gerenciais personalizados</li>
              <li><ImPointRight /> CRM para gestão de clientes</li>
            </ul>

            <strong><span className="purple">2. Plataforma de E-commerce:</span></strong>
            <ul>
              <li><ImPointRight /> Loja virtual profissional e responsiva</li>
              <li><ImPointRight /> Integração com marketplaces</li>
              <li><ImPointRight /> Gateway de pagamentos seguro</li>
              <li><ImPointRight /> Gestão automatizada de pedidos</li>
              <li><ImPointRight /> Ferramentas de marketing digital</li>
            </ul>

            <br />
            Nossas soluções são desenvolvidas para operar de forma <span className="purple">independente ou integrada</span>, conforme a necessidade de cada cliente. Utilizamos tecnologia de ponta para oferecer sistemas robustos, seguros e escaláveis.

            <br /><br />
            Seja qual for sua necessidade - <span className="purple">organizar a gestão do seu negócio</span> ou <span className="purple">criar/expandir suas vendas online</span> - a Quantum Tech tem a solução ideal para você.
          </p>

          <br />

          <p style={{ color: "rgb(155 126 172)" }}>
            "Tecnologia é melhor quando une pessoas"{" "}
          </p>
          <footer className="blockquote-footer">Matt Mullenweg</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;